export const Linking = {
  openURL,
  getInitialURL,
  addEventListener,
};
export default Linking;

function openURL(url: string) {
  window.open(url, '_blank');
}

function getInitialURL() {
  return Promise.resolve(window?.location?.href ?? null);
}
function addEventListener(_ignore: any, handler: any) {
  window.addEventListener('hashchange', () => {
    const url = window?.location?.href;
    if (url) {
      handler?.(url);
    }
  });
  return {
    remove: () => {
      window.removeEventListener('hashchange', handler);
    },
  };
}
